<app-admin-users class="users"></app-admin-users>

<app-admin-roles class="roles"></app-admin-roles>

<app-subscription-plans class="subscriptions"></app-subscription-plans>

<app-promo-codes class="promo-codes"></app-promo-codes>
